import dayjs from 'dayjs';

export const formatDate = (v: Date | null): string =>
    v === null ? '-' : dayjs(v).format('YYYY-MM-DD');
